import { IFirstHandReport } from 'api/resort/types';
import { ILightboxImage, Lightbox } from 'components/common/Lightbox';
import { SvgCalendar } from 'components/icons';
import React, {
  useCallback, useMemo, useRef, useState,
} from 'react';
import { formatAgoTimestampOrString } from 'util/formatAgo';
import classNames from 'classnames';
import { ReadMore } from 'components/common/ReadMore';
import { Diagnostics } from 'util/diagnostics';
import { useVisibilityWindow } from 'util/useVisibilityWindow';
import styles from './styles.module.scss';

export const Report = ({
  report, className,
}: {
  report: IFirstHandReport,
  className?: string,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const isVisible = useVisibilityWindow(ref, true);

  const images: Array<ILightboxImage> = useMemo(() => [{
    title: `${report.name}`,
    alt: `${report.body || report.name}`,
    src: report.largeImage || report.image || '',
  }], []);

  const [lightBoxIndex, setLightBoxOpen] = useState<boolean>(false);

  const closeLightBox = useCallback(() => {
    setLightBoxOpen(false);
  }, [setLightBoxOpen]);

  const openLightBox = useCallback(() => {
    setLightBoxOpen(true);
  }, [setLightBoxOpen]);

  if (!(report.body) && !(report.image)) {
    Diagnostics.error({ message: 'Report has no image and body', tag: 'First Hand Report', data: report });
    return null;
  }

  return (
    <>
      <div className={classNames(styles.wrapper, className)} ref={ref}>
        <div className={styles.box}>
          {/* eslint-disable-next-line */}
          {report.image && isVisible && <img src={report.image} className={styles.image} onClick={openLightBox} alt='' />}
          <div className={styles.head}>
            <div className={styles.date}>
              <SvgCalendar />
              <span>{formatAgoTimestampOrString(report.date)}</span>
            </div>
            <span className={classNames('h3', styles.h3)}>{report.name}</span>
          </div>
          { report.body && <ReadMore text={report.body} length={300} buttonClass={styles.btnReadMore} /> }
        </div>
      </div>
      {lightBoxIndex
    && <Lightbox onClose={closeLightBox} images={images} index={0} />}
    </>
  );
};
